import { UserService } from '@admin/states';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { PendingApprovalCountService, PendingApprovalCounts } from '@ngx-hal/web-services';
import { Observable, distinctUntilChanged, filter, withLatestFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PendingApprovalCountsService {
  readonly pendingCounts$: Observable<PendingApprovalCounts | null>;

  constructor(
    private readonly pendingApprovalCountService: PendingApprovalCountService,
    private readonly userService: UserService,
    router: Router,
  ) {
    this.pendingCounts$ = this.userService.onlyForApprovers(
      this.pendingApprovalCountService.pendingCounts$,
    );

    this.userService.isApprover$
      .pipe(distinctUntilChanged())
      .subscribe(isApprover => {
        if (isApprover) {
          this.refreshPendingCounts();
        } else {
          this.pendingApprovalCountService.clearPendingCounts();
        }
      });

    router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        withLatestFrom(this.userService.isApprover$),
      )
      .subscribe(([, isApprover]) => {
        if (isApprover) this.refreshPendingCounts();
      });
  }

  private refreshPendingCounts(): void {
    this.pendingApprovalCountService.refreshPendingCounts().subscribe({
      error: () => this.pendingApprovalCountService.clearPendingCounts(),
    });
  }
}